export default "__VITE_ASSET__DXKP0xzi__"